import React from "react";
import ContentLoader from "react-content-loader";

const TableSkeletonLoader = ({ width = 1800, height = 60 }) => {
  return (
    <ContentLoader
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      {/* First column (Conference) */}
      <rect x="10" y="20" rx="4" ry="4" width="200" height="20" />

      {/* Remaining 15 columns */}
      {[...Array(15)].map((_, i) => (
        <rect
          key={i}
          x={220 + i * 80}
          y="20"
          rx="4"
          ry="4"
          width="60"
          height="20"
        />
      ))}
    </ContentLoader>
  );
};

export default TableSkeletonLoader;